import moment from 'moment';
import { useGlobal } from '@/utils/useGlobal';

const useEmailConfig = (locale: 'us' | 'ca') => {
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD');

    const emailConfig = {
        us: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1178547779',
            fields: [
                {
                    id: '4423',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: false,
                },
                {
                    id: '11150',
                    type: 'multiple',
                    value: [20, 21, 22],
                    overwrite: false,
                },
                {
                    id: '13030',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        ca: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1496511022',
            fields: [
                {
                    id: '4424',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: false,
                },
                {
                    id: '11150',
                    type: 'multiple',
                    value: [20, 21, 22],
                    overwrite: false,
                },
                {
                    id: '13030',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        eu: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1547528001',
            fields: [
                {
                    id: '4427',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        uk: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1846606487',
            fields: [
                {
                    id: '4430',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        de: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1931025920',
            fields: [
                {
                    id: '4425',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        fr: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1607239600',
            fields: [
                {
                    id: '4428',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        it: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1844328241',
            fields: [
                {
                    id: '4429',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        es: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1938148295',
            fields: [
                {
                    id: '4426',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        ph: {
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1938148295',
            fields: [
                {
                    id: '4426',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '13629',
                    type: 'multiple',
                    value: [2, 3, 4],
                    overwrite: false,
                },
                {
                    id: '13619',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
    };

    return emailConfig[locale];
};

export default useEmailConfig;
